<!--初心词-->
<template>
  <div style="font-size: 60px;margin: 10px;letter-spacing: 10px;text-align: center;color: #ffffff">
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        做简单的更好
      </el-col>
    </el-row>
  </div>

</template>

<script>
export default {
  name: "InitialHeart"
}
</script>

<style scoped>

</style>
